import {
  GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT as hi,
  GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT as li,
} from "../common/constants.js";
export default class Qt {
  constructor(
    t = 0,
    i = [],
    s = [],
    h = [],
    e = null,
    l = null,
    r = { enabled: !1 },
    a = { enabled: !1, refresh_rate_limit: void 0 },
    n = { enabled: !0, capacity: hi, refill_rate: li, endpoint_overrides: {} },
    o = null,
  ) {
    (this.dl = t),
      (this.Rl = i),
      (this.Cl = s),
      (this.El = h),
      (this.yl = e),
      (this.fl = l),
      (this.vl = r),
      (this.De = a),
      (this.bl = n),
      (this.banners = o),
      (this.dl = t),
      (this.Rl = i),
      (this.Cl = s),
      (this.El = h),
      (this.yl = e),
      (this.fl = l),
      (this.vl = r),
      (this.De = a),
      (this.bl = n),
      (this.banners = o);
  }
  bt() {
    return {
      s: "5.9.1",
      l: this.dl,
      e: this.Rl,
      a: this.Cl,
      p: this.El,
      m: this.yl,
      v: this.fl,
      c: this.vl,
      f: this.De,
      grl: this.bl,
      b: this.banners,
    };
  }
  static Rn(t) {
    let i = t.l;
    return (
      "5.9.1" !== t.s && (i = 0),
      new Qt(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f, t.grl, t.b)
    );
  }
}
